import {
  AlertaPersonalizadaSchema,
  ListaDeAlertasPropiasSchema,
  type EdicionDeAlerta,
  type NuevaAlerta,
} from '@cnc/contracts';
import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query';
import {z} from 'zod';
import {json, pedir} from './cliente';

// Alertas propias (decision 0037): abiertas o de una o varias exportaciones.
// Viven bajo la clave 'seguimiento' para que el panel de alertas y el detalle
// de cada exportacion se refresquen al crear, resolver o borrar.
export function useAlertasPropias(estado: 'activa' | 'resuelta' | 'todas' = 'activa', activo = true) {
  return useQuery({
    queryKey: ['seguimiento', 'alertas-propias', estado],
    queryFn: () => pedir(`seguimiento/alertas-propias?estado=${estado}`, ListaDeAlertasPropiasSchema),
    enabled: activo,
  });
}

function useRefrescar() {
  const cliente = useQueryClient();
  return async () => {
    await cliente.invalidateQueries({queryKey: ['seguimiento']});
  };
}

export function useCrearAlerta() {
  const refrescar = useRefrescar();
  return useMutation({
    mutationFn: (nueva: NuevaAlerta) =>
      pedir('seguimiento/alertas-propias', AlertaPersonalizadaSchema, json('POST', nueva)),
    onSuccess: refrescar,
  });
}

export function useEditarAlerta() {
  const refrescar = useRefrescar();
  return useMutation({
    mutationFn: ({id, cambios}: {id: number; cambios: EdicionDeAlerta}) =>
      pedir(`seguimiento/alertas-propias/${id}`, AlertaPersonalizadaSchema, json('PATCH', cambios)),
    onSuccess: refrescar,
  });
}

export function useEliminarAlerta() {
  const refrescar = useRefrescar();
  return useMutation({
    // La API responde 204 sin cuerpo.
    mutationFn: (id: number) => pedir(`seguimiento/alertas-propias/${id}`, z.null(), json('DELETE')),
    onSuccess: refrescar,
  });
}
